<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="true"
      max-width="1024"
      persistent
      scrollable
    >
      <data-card
        :color="$t(`Route.${parentComponentName}.Color`)"
        :colored-border="true"
        :icon="$t(`Route.${parentComponentName}.Icon`)"
        class="election-voters-dialog-datatable"
        title="Λίστα Ψηφισάντων"
      >
        <template #toolbar-append>
          <v-btn
            icon
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>

        <template #default>
          <v-card-text
            v-if="election"
            ref="formContainer"
            class="pa-0"
          >
            <v-card
              class="fill-height"
              flat
            >
              <v-card-title class="pa-2 d-block">
                <v-toolbar
                  :color="!$vuetify.theme.dark ? 'grey lighten-3' : ''"
                  extension-height="60"
                  flat
                >
                  <template #default>
                    <div class="flex-grow-1" />

                    <data-table-search
                      v-if="dataTable.search.enabled"
                      v-model="dataTable.search.terms"
                    />
                  </template>
                </v-toolbar>
              </v-card-title>

              <v-data-table
                :footer-props="{itemsPerPageOptions: [5,10,15,20,25]}"
                :headers="dataTable.headers"
                :height="dataTable.resize.bodyHeight"
                :items="dataTable.data"
                :loading="dataTable.loading"
                :options.sync="dataTable.options"
                :search="dataTable.search.terms"
                :server-items-length="dataTable.total"
                fixed-header
                item-key="Id"
              >
                <template #[`item.VoteType`]="{item}">
                  <v-chip
                    :color="item.IsOffline ? 'info' : 'green'"
                    class="justify-center"
                    label
                    small
                    style="min-width: 75px;"
                  >
                    {{ item.IsOffline ? 'OFFLINE' : 'ONLINE' }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </template>
      </data-card>
    </v-dialog>
  </v-row>
</template>

<script>
import DialogVisible      from '@/mixins/dialog/dialogVisible'
import DataTable          from '@/mixins/table/dataTable'
import DataTableActions   from '@/mixins/table/dataTableActions'
import { themeUtils }     from '@/lib/utils'
import AutoUpdateApiData  from '@/mixins/api/autoUpdateApiData'
import ElectionVoterModel from '@/api/models/election/ElectionVoterModel'

const DataCard = () => themeUtils.importThemeComponent('components/common/DataCard')
const DataTableSearch = () => themeUtils.importThemeComponent('components/common/dataTable/DataTableSearch')

export default {
  name      : 'ElectionVoters',
  components: {
    DataCard,
    DataTableSearch
  },
  directives: {},
  mixins    : [DialogVisible, DataTable, DataTableActions, AutoUpdateApiData],
  props     : {
    election: {
      type   : Object,
      default: undefined
    }
  },
  enums    : {},
  dataModel: ElectionVoterModel,
  data () {
    return {
      parentComponentName     : this.$parent.$options.name,
      autoUpdateApiDataOptions: {
        timeout  : 15000,
        autoStart: false,
        callback : this.getData,
        interval : null
      },
      dataTable: {
        containerElementClass: 'election-voters-dialog-datatable',
        payload              : { Id: this.election?.Id },
        customFilter         : {},
        filter               : {
          Active: null
        },
        resize: {
          enabled        : true,
          debounceTimeout: null,
          bodyHeight     : undefined,
          offset         : -20
        },
        options: {
          sortBy  : ['Id'],
          sortDesc: [true]
        },
        headers: [
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.Id`) ? this.$t(`${ this.$options.name }.Table.Headers.Id`) : '#',
            value   : 'Id',
            align   : 'left',
            sortable: true
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.Uid`) ? this.$t(`${ this.$options.name }.Table.Headers.Uid`) : 'Uid',
            value   : 'Uid',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.Corps`) ? this.$t(`${ this.$options.name }.Table.Headers.Corps`) : 'Corps',
            value   : 'Corps',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.FirstName`) ? this.$t(`${ this.$options.name }.Table.Headers.FirstName`) : 'FirstName',
            value   : 'FirstName',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.LastName`) ? this.$t(`${ this.$options.name }.Table.Headers.LastName`) : 'LastName',
            value   : 'LastName',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.FathersName`) ? this.$t(`${ this.$options.name }.Table.Headers.FathersName`) : 'FathersName',
            value   : 'FathersName',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.Phone`) ? this.$t(`${ this.$options.name }.Table.Headers.Phone`) : 'Phone',
            value   : 'Phone',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.Email`) ? this.$t(`${ this.$options.name }.Table.Headers.Email`) : 'Email',
            value   : 'Email',
            align   : 'left',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.VoteType`) ? this.$t(`${ this.$options.name }.Table.Headers.VoteType`) : 'VoteType',
            value   : 'VoteType',
            align   : 'center',
            sortable: false
          },
          {
            text    : this.$te(`${ this.$options.name }.Table.Headers.Time`) ? this.$t(`${ this.$options.name }.Table.Headers.Time`) : 'Time',
            value   : 'Time',
            align   : 'center',
            sortable: false
          }
        ]
      }
    }
  },
  computed: {},
  watch   : {
    election (val) {
      this.dataTable.payload = { Id: val?.Id }
    },

    isVisible (val) {
      if (val) {
        this.getData()
        this.startAutoUpdateApiData(this.autoUpdateApiDataOptions.callback)
        this.$nextTick(() => {
          this.$nextTick(() => {
            this.calcTableBodyHeight()
          })
        })
      } else {
        this.stopAutoUpdateApiData()
      }
    }
  },
  beforeCreate () {},
  created () {},
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {}
}
</script>

<style scoped>

</style>
